<template>
    <div class="row">
        <div class="d-none d-md-block col-xl-5 ml-auto measurement-details-wrapper">
            <h3>{{ focusedMeasurement.name }}</h3>
            <img :src="focusedMeasurement.image" :alt="focusedMeasurement.name">
            <p class="focused-description">{{ focusedMeasurement.description }}</p>
        </div>
        <Modal v-model="showDetailsModal" class="d-md-none details-modal">
            <img :src="focusedMeasurement.image" :alt="focusedMeasurement.name">
            <h3>{{ focusedMeasurement.name }}</h3>
            <p class="focused-description">{{ focusedMeasurement.description }}</p>
        </Modal>
        <div class="col-xl-3 mr-auto measurement-fields-wrapper">
            <div class="row measurement-inputs-wrapper">
                <div class="col-12">
                    <AutofillMeasurements :type="type"/>
                </div>
                <div class="col-sm-6"
                     v-for="(measurement, id) in $backendConfig.measurements.categories[type]"
                     :key="id">
                    <MeasurementInputBox :measurement="measurement"
                                         @focus="focusedField = id"
                                         @openHelper="focusedField = id; showDetailsModal = true"
                                         :validate="validate"/>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <InputBox v-model="height"
                              :label-class="heightInvalid ? 'invalid' : (!!height ? 'validated' : '')"
                              :label="baseCategories.height.name"
                              :unit="baseCategories.height.unit"
                              icon="height-field"/>
                </div>
                <div class="col-sm-6">
                    <InputBox v-model="weight"
                              :label-class="!!weight ? 'validated' : ''"
                              :label="baseCategories.weight.name"
                              :unit="baseCategories.weight.unit"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputBox from "./InputBox";
import MeasurementInputBox from "./MeasurementInputBox";
import Modal from "../common/Modal";
import AutofillMeasurements from "./AutofillMeasurements";

export default {
    name: "MeasurementsForm",
    components: {AutofillMeasurements, Modal, MeasurementInputBox, InputBox},
    props: [
        "baseCategories",
        "type",
        "validate",
    ],
    data() {
        return {
            heightInvalid: 0,
            focusedField: "collar",
            showDetailsModal: false
        };
    },
    watch: {
        validate(value) {
            if (value)
                this.heightInvalid = !this.height;
        }
    },
    computed: {
        focusedMeasurement() {
            return this.$backendConfig.measurements.categories[this.type][this.focusedField];
        },
        weight: {
            get() {
                return this.$db.measurements.weight;
            },
            set(value) {
                this.$set(this.$db.measurements, "weight", value);
            }
        },
        height: {
            get() {
                return this.$db.measurements.height;
            },
            set(value) {
                this.$set(this.$db.measurements, "height", value);
                this.heightInvalid = !this.height;
            }
        }
    },
}
</script>

<style scoped>

</style>
